import { useAtomValue } from 'jotai';
import { useSidePanel } from '../side-panel-provider';
export const useFilteredAnnotations = () => {
  const {
    filteredAnnotationsAtom
  } = useSidePanel();
  const annotations = useAtomValue(filteredAnnotationsAtom);
  return annotations;
};